import services from './../../services/service'; // Service Class
import Preset from './../../mixins/preset.js'; //preset
//
import DataServer from '../../mixins/dataserver.js'; //DataSharableServing Class
import CNpaymentModal from './../../templates/CNpaymentModal/index.vue' //payent modal
// import RegService from '../../templates/RegisterService/index.vue'; //call the register class
//
//import Maps from '../../mixins/map.js';

let service = new services();

export default {
    name: 'CNdiscounts',
    mixins: [Preset,DataServer],
    props: {
        cndiscount:Object,
        cndiscount_set_view:"",
    },
    data () {
        return {
            can_set_discount: false,
            set_new_business:false,
            // user: {},
            cndiscounts:{},
            // cndiscount:{},
            // cndiscount_set_view:"form_view",
            preview_form: false,
            view_info:false,
            // businesses: {},
            // business: {},
            cnsurveys: {},
            search: {},
            search_result: "",
            search_message: "",
            panelFlag: false,
            addFlag: false,
            img_url: service.imageURL,
            page_data: {},
            pag_intv: service.pageIntv,
            reviews: {},
            review: {},
            rate: "",
            has_reviewed: false,
            has_rated: false,
            current_page: 0,
            search_mode: false,
            disable_btn: false,
            process_loading: false,
            //
            //Set up some of our variables.
            map: '', //Will contain map object.
            marker: false, ////Has the user plotted their location marker? 
            mapComponentKey:0,
        }
    },
    components: {
       'cnpayment-modal': CNpaymentModal,
        // 'set-reg': RegService,
    },
    computed: {
        rateValue: {
            get(){
                //this function will determine what is displayed in the input
                return this.rate;
            },
            set(newVal){
                //this function will run whenever the input changes
                if(this.user.user_id != null){
                    this.rate = newVal;
                    this.rateBusiness();
                }else{
                    localStorage.setItem("cn_prv_page","businesses");//log current page
                    this.preset();
                }
            }
        }
    },
    methods: {
        toggleComponent(id){
            var stl = document.getElementById(id).style.display;
            if(stl == "block"){
                document.getElementById(id).style = "display:none";
            }else{
                document.getElementById(id).style = "display:block";
            }
        },

        isActive(page){
            if(page == this.current_page){
                return true;
            }
        },

        setReload(){
            location.reload();
        },

        setPreps(){
            this.set_payment_details_data = this.payment_details_data;
            //check business status
            this.set_payment_object_title = "Make DiscountBazaar Payment"; //extended params //may be faster than parents //check effect if redone
            //payment checks
            if(this.cndiscount_set_view == 'payment_view'){
                this.set_payment_view = true;
            }
        },

        setReg(){
            localStorage.setItem("current_page",'cndiscountsetup');
            location.replace('register');
        },

        setAddNewBusiness(){
            this.business = {};
            this.set_new_business = true;
        },
        
        initMap() {
            // The location of cn
            // const cn = { lat: -25.344, lng: 131.036 };
            const cn = {lat: 8.985714, lng: 7.4465517}
            // The map, centered at cn
            this.map = new google.maps.Map(document.getElementById("map00"), {
                zoom: 18,
                center: cn,
            });
            // The marker, positioned at cn
            this.marker = new google.maps.Marker({
                position: cn,
                map: this.map,
            });
             
            //
            let self = this;
            //Listen for any clicks on the map.
            google.maps.event.addListener(self.map, 'click', function(event) {  console.log(903)              
                //Get the location that the user clicked.
                var clickedLocation = event.latLng;console.log(self.map)  
                
                //If the marker hasn't been added.
                if(self.marker === false){console.log(9038)  
                    //Create the marker.
                    self.marker = new google.maps.Marker({
                        position: clickedLocation,
                        map: self.map,
                        draggable: true //make it draggable
                    });
                    //Listen for drag events!
                    google.maps.event.addListener(self.marker, 'dragend', function(event){
                        self.markerLocation();
                    });
                } else{console.log(9203)  
                    //Marker has already been added, so just change its location.
                    self.marker.setPosition(clickedLocation);
                }
                //Get the marker's location.
                self.markerLocation();
            });

        },

        //This function will get the marker's current location and then add the lat/long
        //values to our textfields so that we can save the location.
        markerLocation(){
            //Get location.
            var currentLocation = this.marker.getPosition();
            console.log('lat: '+currentLocation.lat());
            console.log('lng: '+currentLocation.lng());
            //
            this.business.map_lat = currentLocation.lat();
            this.business.map_lng = currentLocation.lng();
            //
            //Add lat and lng values to a field that we can save.
            //document.getElementById('lat').value = currentLocation.lat(); //latitude
            //document.getElementById('lng').value = currentLocation.lng(); //longitude
            //
            this.mapComponentKey++;
        }
    },
    mounted: function(){
        // this.initMap();
        let self = this;
        setTimeout(function (){
            self.initMap('map00')
        }, 3000);
        //
        this.setPreps();
        // function initialize() {
        //     var myLatlng = new google.maps.LatLng(51.508742,-0.120850);
        //   var mapProp = {
        //     center:myLatlng,
        //     zoom:5,
        //     mapTypeId:google.maps.MapTypeId.ROADMAP
              
        //   };
        //   var map=new google.maps.Map(document.getElementById("googleMap"), mapProp);
        //     var marker = new google.maps.Marker({
        //       position: myLatlng,
        //       map: map,
        //       title: 'Hello World!',
        //       draggable:true  
        //   });
        //     document.getElementById('lat').value= 51.508742
        //     document.getElementById('lng').value= -0.120850  
        //     // marker drag event
        //     google.maps.event.addListener(marker,'drag',function(event) {
        //         document.getElementById('lat').value = event.latLng.lat();
        //         document.getElementById('lng').value = event.latLng.lng();
        //     });
        
        //     //marker drag event end
        //     google.maps.event.addListener(marker,'dragend',function(event) {
        //         document.getElementById('lat').value = event.latLng.lat();
        //         document.getElementById('lng').value = event.latLng.lng();
        //         alert("lat=>"+event.latLng.lat());
        //         alert("long=>"+event.latLng.lng());
        //     });
        // }
        
        // google.maps.event.addDomListener(window, 'load', initialize);
    },
    created: function(){
        this.initMap();
        let u_t = localStorage.getItem("cityneeds_token");
        if((u_t != null)) {
            this.preset();
        }else{
            localStorage.setItem("cn_prv_page","businesses");//log current page
        }
        
        //this.getSearchBusiness();
        // this.getAllBusinesses();
        // this.getAllBusinesses(0,this.pag_intv);
        // this.getCNdiscounts(0,this.pag_intv);
     }
}


// WEBPACK FOOTER //
// ./src/templates/CNdiscountForm/script.js